/* Flycatcher Bundle Builder checkout return handler */

(() => {
  if (window.flycatcherBundleCheckoutReturnInitialized) return;
  window.flycatcherBundleCheckoutReturnInitialized = true;

  const markerKey = 'flycatcher.bundleCheckoutPending';
  const cookieMarkerKey = 'flycatcher_bundle_checkout_pending';
  let clearPromise = null;

  function readCookie(name) {
    const row = document.cookie
      .split('; ')
      .find(value => value.startsWith(`${name}=`));

    if (!row) return null;

    return row.slice(name.length + 1);
  }

  function removeMarker() {
    try {
      sessionStorage.removeItem(markerKey);
    } catch (error) {}

    try {
      localStorage.removeItem(markerKey);
    } catch (error) {}

    try {
      document.cookie =
        `${cookieMarkerKey}=; Max-Age=0; Path=/; SameSite=Lax`;
    } catch (error) {}
  }

  function readMarker() {
    try {
      const raw =
        sessionStorage.getItem(markerKey) ||
        localStorage.getItem(markerKey) ||
        readCookie(cookieMarkerKey);

      if (!raw) return null;

      const marker = JSON.parse(decodeURIComponent(raw));

      if (!marker?.bundleId || !marker?.bundleHandle || !marker?.startedAt) {
        removeMarker();
        return null;
      }

      if (Date.now() - Number(marker.startedAt) > 30 * 60 * 1000) {
        removeMarker();
        return null;
      }

      return marker;
    } catch (error) {
      removeMarker();
      return null;
    }
  }

  function removeSavedBundleState(marker) {
    try {
      sessionStorage.removeItem(`flycatcher.bundle.${marker.bundleHandle}`);
    } catch (error) {
      // Storage can be unavailable in privacy-restricted browsers.
    }
  }

  function dispatchResult(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  }

  function synchronizeThemeCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = '0';
      element.setAttribute('aria-label', '0 items');
    });

    document.querySelectorAll('.cart-link__bubble').forEach((element) => {
      element.classList.remove('cart-link__bubble--visible');
    });

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart }
    }));

    document.dispatchEvent(new CustomEvent('cart:build', {
      detail: { cart }
    }));
  }

  async function clearReturnedCheckoutCart() {
    const marker = readMarker();

    if (!marker) return false;
    if (clearPromise) return clearPromise;

    document.documentElement.classList.add('bundle-checkout-return-is-clearing');

    clearPromise = (async () => {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/clear.js`, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({})
      });

      if (!response.ok) {
        throw new Error(`Unable to clear the cart (${response.status}).`);
      }

      const cart = await response.json();

      removeSavedBundleState(marker);
      removeMarker();
      synchronizeThemeCart(cart);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'bundle_cart_cleared_after_checkout',
        bundle_id: marker.bundleId,
        bundle_type: marker.bundleHandle
      });

      dispatchResult('bundle:checkout-return:cleared', {
        bundleId: marker.bundleId,
        bundleHandle: marker.bundleHandle,
        cart
      });

      return true;
    })().catch((error) => {
      document.documentElement.classList.remove('bundle-checkout-return-is-clearing');

      console.error('Bundle Builder: unable to clear the cart after checkout.', error);
      dispatchResult('bundle:checkout-return:error', {
        message: error.message || 'Unable to clear the cart.'
      });

      clearPromise = null;
      return false;
    });

    return clearPromise;
  }

  function initialize() {
    clearReturnedCheckoutCart();

    setTimeout(() => {
      clearReturnedCheckoutCart();
    }, 500);

    setTimeout(() => {
      clearReturnedCheckoutCart();
    }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.addEventListener('pageshow', initialize);

  window.FlycatcherBundleCheckoutReturn = {
    check: clearReturnedCheckoutCart
  };
})();
